import { AnimationClip, LoopOnce, Mesh } from "three";
import { ACTION_TRIGGERS } from "./webar-core/framework/ActionTriggers";
import { PROJECT_TRIGGERS } from "./projectTriggers";
import { AudioAsset, GltfAsset } from "./webar-core/framework/store/AssetSlice";
import { useStore } from "./webar-core/framework/store/Store";
import {
  trackBottleTap,
  trackFoodPaired,
  trackReachedEnd,
} from "./webar-core/framework/utils/gtag";
const addAction = useStore.getState().addAction;
const triggerAction = useStore.getState().triggerAction;

export const setupActions = () => {
  let enableBottleTap = false;
  let enableChoiceTap = false;
  let enableFinalTap = false;
  let tapsFound = [0, 0, 0, 0, 0, 0];
  let currentBottle = "";

  addAction({
    target: "canvas",
    trigger: ACTION_TRIGGERS.EXPERIENCE_START,
    cb: (target) => {},
  });

  addAction({
    // Room animation to idle
    target: "room",
    trigger: PROJECT_TRIGGERS.ENABLE_BOTTLE_TAP,
    cb: (target, event) => {
      enableBottleTap = true;
    },
  });

  // ---------------- COLLIDERS BOTTLES MAIN
  addAction({
    target: "tapBottleIntro",
    trigger: ACTION_TRIGGERS.TAP,
    cb: (target, event) => {
      if (enableBottleTap) {
        (
          useStore
            .getState()
            .assets.get("raycastingTapSoundEffect") as AudioAsset
        ).play();
        enableBottleTap = false;
        const room = useStore.getState().assets.get("room")! as GltfAsset;
        const roomMixer = room.animation.mixer;

        let clipMain = null;
        let clipChoice = null;
        let clipIdle = null;

        if (event.name === "colliderBottles18") {
          tapsFound[0] = 1;
          clipMain = room.animation.clips[3];
          clipChoice = room.animation.clips[4];
          clipIdle = room.animation.clips[5];
          currentBottle = "18";
        } else if (event.name === "colliderBottles21") {
          tapsFound[1] = 1;
          clipMain = room.animation.clips[8];
          clipChoice = room.animation.clips[9];
          clipIdle = room.animation.clips[10];
          currentBottle = "21";
        } else if (event.name === "colliderBottles25") {
          tapsFound[2] = 1;
          clipMain = room.animation.clips[13];
          clipChoice = room.animation.clips[14];
          clipIdle = room.animation.clips[15];
          currentBottle = "25";
        }

        triggerAction(PROJECT_TRIGGERS.ANIMATE_GEMS, "canvas", undefined, {
          tapsFound,
        });

        const clip_bottle_intro_idle = roomMixer.clipAction(
          room.animation.clips[2],
          room.gltf.scene
        );

        const clip_bottle_main = roomMixer.clipAction(
          clipMain as AnimationClip,
          room.gltf.scene
        );
        clip_bottle_main.clampWhenFinished = true;
        clip_bottle_main.loop = LoopOnce;

        const clip_choice = roomMixer.clipAction(
          clipChoice as AnimationClip,
          room.gltf.scene
        );
        clip_choice.clampWhenFinished = true;
        clip_choice.loop = LoopOnce;

        const clip_idle = roomMixer.clipAction(
          clipIdle as AnimationClip,
          room.gltf.scene
        );

        const playChoiceIdle = () => {
          roomMixer.removeEventListener("finished", playChoiceIdle);
          clip_choice.stop();
          enableChoiceTap = true;
          triggerAction(
            PROJECT_TRIGGERS.CONTROL_CLICKABLE,
            "canvas",
            undefined,
            { bottles: false, choice: true, surprise: false }
          );

          clip_idle.play();
        };

        const playChoice = () => {
          roomMixer.removeEventListener("finished", playChoice);
          clip_bottle_main.stop();

          roomMixer.addEventListener("finished", playChoiceIdle);
          setTimeout(() => {
            (
              useStore
                .getState()
                .assets.get(`choice${currentBottle}SoundEffect`) as AudioAsset
            ).play();
            (
              useStore
                .getState()
                .assets.get(`choice${currentBottle}VO`) as AudioAsset
            ).play();
          }, 500);

          clip_choice.play();
        };

        roomMixer.addEventListener("finished", playChoice);
        (
          useStore
            .getState()
            .assets.get(`bottle${currentBottle}SoundEffect`) as AudioAsset
        ).play();
        (
          useStore.getState().assets.get(`main${currentBottle}VO`) as AudioAsset
        ).play();

        trackBottleTap(currentBottle);
        clip_bottle_intro_idle.stop();
        clip_bottle_main.play();
      }
    },
  });
  // ---------------- COLLIDERS TASTES
  addAction({
    target: "tapTaste",
    trigger: ACTION_TRIGGERS.TAP,
    cb: (target, event) => {
      if (enableChoiceTap) {
        enableChoiceTap = false;
        const room = useStore.getState().assets.get("room")! as GltfAsset;
        const roomMixer = room.animation.mixer;

        let clipTaste = null;

        if (currentBottle === "18") {
          tapsFound[3] = 1;
          clipTaste = room.animation.clips[6];
        } else if (currentBottle === "21") {
          tapsFound[4] = 1;
          clipTaste = room.animation.clips[11];
        } else if (currentBottle === "25") {
          tapsFound[5] = 1;
          clipTaste = room.animation.clips[16];
        }

        triggerAction(PROJECT_TRIGGERS.ANIMATE_GEMS, "canvas", undefined, {
          tapsFound,
        });

        const clip_bottle_intro_idle = roomMixer.clipAction(
          room.animation.clips[2],
          room.gltf.scene
        );

        const clip__idle_18 = roomMixer.clipAction(
          room.animation.clips[5],
          room.gltf.scene
        );
        const clip__idle_21 = roomMixer.clipAction(
          room.animation.clips[10],
          room.gltf.scene
        );
        const clip__idle_25 = roomMixer.clipAction(
          room.animation.clips[15],
          room.gltf.scene
        );

        const clip_taste = roomMixer.clipAction(
          clipTaste as AnimationClip,
          room.gltf.scene
        );
        clip_taste.clampWhenFinished = true;
        clip_taste.loop = LoopOnce;

        const resetBottles = () => {
          roomMixer.removeEventListener("finished", resetBottles);
          enableBottleTap = true;
          clip_taste.stop();
          clip_bottle_intro_idle.play();
          currentBottle = "";
          triggerAction(PROJECT_TRIGGERS.FOUND_GEMS, "canvas");
          triggerAction(
            PROJECT_TRIGGERS.CONTROL_CLICKABLE,
            "canvas",
            undefined,
            { bottles: true, choice: false, surprise: false }
          );
        };

        roomMixer.addEventListener("finished", resetBottles);
        clip__idle_18.stop();
        clip__idle_21.stop();
        clip__idle_25.stop();
        (
          useStore
            .getState()
            .assets.get(`cask${currentBottle}SoundEffect`) as AudioAsset
        ).play();
        (
          useStore.getState().assets.get(`cask${currentBottle}VO`) as AudioAsset
        ).play();
        trackFoodPaired(currentBottle);
        clip_taste.play();
      }
    },
  });
  // ---------------- COLLIDERS BACK
  addAction({
    target: "tapBack",
    trigger: ACTION_TRIGGERS.TAP,
    cb: (target, event) => {
      if (enableChoiceTap) {
        enableChoiceTap = false;
        const room = useStore.getState().assets.get("room")! as GltfAsset;
        const roomMixer = room.animation.mixer;

        let clipBack = null;

        if (currentBottle === "18") {
          clipBack = room.animation.clips[7];
        } else if (currentBottle === "21") {
          clipBack = room.animation.clips[12];
        } else if (currentBottle === "25") {
          clipBack = room.animation.clips[17];
        }

        const clip_bottle_intro_idle = roomMixer.clipAction(
          room.animation.clips[2],
          room.gltf.scene
        );

        const clip__idle_18 = roomMixer.clipAction(
          room.animation.clips[5],
          room.gltf.scene
        );
        const clip__idle_21 = roomMixer.clipAction(
          room.animation.clips[10],
          room.gltf.scene
        );
        const clip__idle_25 = roomMixer.clipAction(
          room.animation.clips[15],
          room.gltf.scene
        );

        const clip_back = roomMixer.clipAction(
          clipBack as AnimationClip,
          room.gltf.scene
        );
        clip_back.clampWhenFinished = true;
        clip_back.loop = LoopOnce;

        const resetBottles = () => {
          roomMixer.removeEventListener("finished", resetBottles);
          enableBottleTap = true;
          clip_back.stop();
          clip_bottle_intro_idle.play();
          currentBottle = "";
          triggerAction(
            PROJECT_TRIGGERS.CONTROL_CLICKABLE,
            "canvas",
            undefined,
            { bottles: true, choice: false, surprise: false }
          );
        };

        roomMixer.addEventListener("finished", resetBottles);
        clip__idle_18.stop();
        clip__idle_21.stop();
        clip__idle_25.stop();
        (
          useStore
            .getState()
            .assets.get(`back${currentBottle}SoundEffect`) as AudioAsset
        ).play();
        clip_back.play();
      }
    },
  });
  // ---------------- FINAL ANIMATION ---------------
  addAction({
    // Room animation to idle
    target: "canvas",
    trigger: PROJECT_TRIGGERS.FOUND_GEMS,
    cb: (target, event) => {
      let totalFound = 0;

      for (const key in tapsFound) {
        totalFound += tapsFound[key];
      }

      if (totalFound === 6) {
        enableBottleTap = false;

        triggerAction(PROJECT_TRIGGERS.ANIMATE_GEMS_BAR, "canvas");

        const room = useStore.getState().assets.get("room")! as GltfAsset;
        const roomMixer = room.animation.mixer;

        const clip_bottle_intro_idle = roomMixer.clipAction(
          room.animation.clips[2],
          room.gltf.scene
        );

        const clip_end = roomMixer.clipAction(
          room.animation.clips[18],
          room.gltf.scene
        );
        clip_end.clampWhenFinished = true;
        clip_end.loop = LoopOnce;

        const clip_surprise = roomMixer.clipAction(
          room.animation.clips[19],
          room.gltf.scene
        );
        clip_surprise.clampWhenFinished = true;
        clip_surprise.loop = LoopOnce;

        const clip_final_idle = roomMixer.clipAction(
          room.animation.clips[20],
          room.gltf.scene
        );

        const finalIdle = () => {
          roomMixer.removeEventListener("finished", finalIdle);
          clip_final_idle.play();
          enableFinalTap = true;
          triggerAction(
            PROJECT_TRIGGERS.CONTROL_CLICKABLE,
            "canvas",
            undefined,
            { bottles: false, choice: false, surprise: true }
          );
        };

        const playSurpriseClip = () => {
          roomMixer.removeEventListener("finished", playSurpriseClip);
          clip_end.stop();

          roomMixer.addEventListener("finished", finalIdle);
          clip_surprise.play();
        };

        roomMixer.addEventListener("finished", playSurpriseClip);
        clip_bottle_intro_idle.stop();
        (useStore.getState().assets.get("surpriseVO") as AudioAsset).play();
        (useStore.getState().assets.get("outroBigMoment") as AudioAsset).play();
        trackReachedEnd();
        clip_end.play();
      }
    },
  });
  // ---------------- FINAL TAP ---------------
  addAction({
    // Room animation to idle
    target: "tapSurprise",
    trigger: ACTION_TRIGGERS.TAP,
    cb: (target, event) => {
      if (enableFinalTap) {
        enableFinalTap = false;
        (
          useStore.getState().assets.get("prizeTapSoundEffect") as AudioAsset
        ).play();

        setTimeout(() => {
          // Delay to be able to hear the raycast tap sound
          window.location.assign(
            "https://www.theglenlivet.com/en/virtual-reality-recipes/"
          );
        }, 200);
      }
    },
  });
};
